import { Component, Input } from '@angular/core';

import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tr-close-day-schedule',
  templateUrl: './close-day-schedule.component.html',
})
export class CloseDayScheduleComponent {
  icon = AppIcon;
  @Input() schedule;
  @Input() closedType: string = 'closed';

  constructor(private readonly modalController: FrontendModalService) { }

  ok(value?: boolean): void {
    this.modalController.dismiss(value);
  }
}
